
import { defineComponent } from 'vue';
import HelloWorld from './components/HelloWorld.vue';
import Profile from './components/Profile.vue';
import Contact from './components/Contact.vue';
import Education from './components/Education.vue';
import Skills from './components/Skills.vue';
import Experience from './components/Experience.vue'

import ResumeLoader from './utilities/ResumeLoader';
import { ResumeProfile, ResumeContact, Resume } from './models/Resume';

export default defineComponent({
  name: 'App',
  components: {
    Profile,
    Contact,
    Education,
    Skills,
    Experience
  },
  data() {
    return {
      resume: ResumeLoader.load()
    }
  }
});

